<template>
    <header class="interactive-header">
        <section class="interactive-header-menu">
            <a class="menu-item" @click="$store.commit('showPresenceList', $store.state.appStore.sessionId);">
                <img src="../../../assets/icons/components/user-check-presence.svg" class="menu-icon" :alt="$t('com.file.meeting-actions.presence-list')" />
                <span class="menu-text">{{$t('com.file.meeting-actions.presence-list')}}</span>
            </a>
            <a class="menu-item" @click="$store.commit('showCheckQourum')" v-if="$store.state.settings.runtime.menuInteractiveShowQorum">
                <img src="../../../assets/icons/components/user-check-quorum.svg" class="menu-icon" :alt="$t('com.file.interactive-header.check-quorum')" />    
                <span class="menu-text">{{$t('com.file.interactive-header.check-quorum')}}</span>
            </a>
            <div class="dropdown">
                <button class="dropbtn">
                    <img src="../../../assets/icons/components/break-time-icon.svg" class="menu-icon" :alt="$t('com.file.break-board.break')" />
                    {{$t('com.file.break-board.break')}}
                    <img src="../../../assets/icons/panel/header/arrow.svg" class="dropdown-arrow" />
                </button>
                <perfect-scrollbar class="dropdown-content">
                    <a class="menu-item" @click="startSessionBrake(5)"><span class="menu-text">{{$t('com.file.speech-timer-config.5minute')}}</span></a>
                    <a class="menu-item" @click="startSessionBrake(10)"><span class="menu-text">{{$t('com.file.speech-timer-config.10minute')}}</span></a>
                    <a class="menu-item" @click="startSessionBrake(15)"><span class="menu-text">{{$t('com.file.speech-timer-config.15minute')}}</span></a>
                    <a class="menu-item" @click="startSessionBrake(20)"><span class="menu-text">{{$t('com.file.speech-timer-config.20minute')}}</span></a>
                    <a class="menu-item" @click="startSessionBrake(30)"><span class="menu-text">{{$t('com.file.speech-timer-config.30minute')}}</span></a>
                    <a class="menu-item" @click="startSessionBrake(45)"><span class="menu-text">{{$t('com.file.speech-timer-config.45minute')}}</span></a>
                    <a class="menu-item" @click="startSessionBrake(60)"><span class="menu-text">{{$t('com.file.speech-timer-config.60minute')}}</span></a>
                    <a class="menu-item" @click="$store.commit('showCustomBreakModal')"><span class="menu-text">{{$t('com.file.speech-timer-config.set-any-time')}}</span></a>
                </perfect-scrollbar>
            </div>
            <a class="menu-item" @click="refreshSession()">
                <img src="../../../assets/icons/components/refresh-list.svg" class="menu-icon" :alt="$t('com.file.interactive-header.refresh-session')" />
                <span class="menu-text">{{$t('com.file.interactive-header.refresh-session')}}</span>
            </a>
            <div class="dropdown">
                <button class="dropbtn">
                    <PulseDot v-if="isAnyActivePlaceholder" v-tooltip="getPlaceholderTooltip()" color="green" />
                    <img src="@/assets/icons/components/presentation-screen.svg" class="menu-icon" :alt="$t('com.file.interactive-header.placeholder')" />
                    {{$t('com.file.interactive-header.placeholder')}}
                    <img src="@/assets/icons/panel/header/arrow.svg" class="dropdown-arrow" />
                </button>
                <div class="dropdown-content">
                    <a class="menu-item" @click="deActivatePlaceholder">
                        <span class="menu-text">{{$t('com.file.interactive-header.placeholder-off')}}</span>
                    </a>
                    <perfect-scrollbar>
                        <a class="menu-item" :class="{'active': currentActivePlaceholder === item.id}" v-for="(item, index) in availablePlaceholders" :key="index" @click="activatePlaceholder(item)">
                            <PulseDot v-if="currentActivePlaceholder === item.id" v-tooltip="getPlaceholderTooltip()" color="green" style="margin: 0px !important" />
                            <span class="menu-text">{{ item.name }}</span>
                        </a>
                    </perfect-scrollbar>
                    <a class="menu-item" @click="$store.commit('setIsShowAddPlaceholderStatus', true)">
                        <img src="@/assets/icons/components/plus-small.svg" style="filter: invert(1);"/>
                        <span class="menu-text">{{$t('com.file.interactive-header.add-placeholder')}}</span>
                    </a>
                </div>
            </div>
            <div class="dropdown" v-if="isDiscussionModule">
                <button class="dropbtn">
                    <img src="@/assets/icons/panel/editSession/meeting-time.svg" class="menu-icon" :alt="$t('com.file.interactive-header.speeker-time')" />
                    {{$t('com.file.interactive-header.speeker-time')}}
                    <img src="@/assets/icons/panel/header/arrow.svg" class="dropdown-arrow" />
                </button>
                <div class="dropdown-content">
                    <perfect-scrollbar>
                        <a class="menu-item" v-for="(item, index) in availableSpeechTime" :key="index" @click="startSpeechTimer(item.value)">
                            <span class="menu-text">{{ $t(item.label) }}</span>
                        </a>
                    </perfect-scrollbar>
                </div>
            </div>
        </section>
    </header>
</template>
<script charset="utf-8">
    import eSesjaInteractiveService from "../../../services/esesja.interactive.service";
    import placeholderService from "../../../services/placeholder.service";
    import PulseDot from "../../../components/BasicControls/PulseDot.vue";
    import { speechTimerConfig } from "@/config/speech-timer.config";
    import SpeechTimerService from "@/services/speech-timer.service";
    import { encryptStorage } from "../../../services/encrypt.service";

    export default {
        name: "InteractiveHeader",
        components: {
            PulseDot
        },
        data() { return {} },
        computed: {
            availablePlaceholders(){
                return this.$store.state.placeholderStore.placeholders;
            },
            currentActivePlaceholder() {
                return this.$store.state.placeholderStore.currentActivePlaceholder;
            },
            isAnyActivePlaceholder() {
                return this.currentActivePlaceholder !== null;
            },
            availableSpeechTime(){
                return speechTimerConfig?.availableOptions ?? [];
            },
            sessionId(){
                return parseInt(this.$route.params.sessionid);
            },
            isDiscussionModule() {
                if (encryptStorage.getItem('modules').d == 1)
                    return true;

                return false;
            },
        },
        async mounted() {
            try{
                await placeholderService.GetAll();
            }
            catch(e){
                console.log(e);
            }
        },
        methods: {
            async startSessionBrake(breakDuration) {
                try {
                    let timestamp = new Date();
                    this.$store.commit("setBreakTimestamp", timestamp);
                    this.$store.commit("setBreakDuration", breakDuration);
                    this.$store.commit("startBreak");

                    await eSesjaInteractiveService.startBreak(breakDuration, this.$store.state.appStore.sessionId, timestamp);
                }
                catch (e) {
                    this.$store.commit("showError");
                }
            },
            async refreshSession() {
                try {
                    await eSesjaInteractiveService.changeInAgendaWithSendToTablet(this.$store.state.appStore.sessionId);
                    await eSesjaInteractiveService.reloadSession(this.$store.state.appStore.sessionId);
                }
                catch (e) {
                    console.log(e)
                    this.$store.commit("showError");
                }
            },
            async activatePlaceholder(placeholder){
                try{
                    await eSesjaInteractiveService.activePlaceholder(this.$store.state.appStore.sessionId, placeholder.id);
                    this.$store.commit("setActivePlaceholder", placeholder.id)
                }
                catch (e) {
                    console.log(e)
                    this.$store.commit("showError");
                }
            },
            async deActivatePlaceholder(){
                try{
                    await eSesjaInteractiveService.deActivePlaceholder(this.$store.state.appStore.sessionId);
                    this.$store.commit("setActivePlaceholder", null)
                }
                catch (e) {
                    console.log(e)
                    this.$store.commit("showError");
                }
            },

            getPlaceholderTooltip() {
                if (!this.isAnyActivePlaceholder) {
                    return ""
                }
                let currentPlaceholder = this.availablePlaceholders.filter(item => item.id === this.currentActivePlaceholder);
                if (currentPlaceholder.length != 1) {
                    return "";
                }

                const place_activ = this.$t('com.file.interactive-header.active-placeholder');
                return `${place_activ}: ${currentPlaceholder[0].name}`;
            },
            async startSpeechTimer(value){
                try{
                    if(!this.isDiscussionModule){
                        return;
                    }
                    await SpeechTimerService.startSpeechTimer(value, this.sessionId);
                }
                catch(e){
                    console.log(e);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use "../../../assets/scss/breakpoints.scss" as *; 
    .interactive-header {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: white;
        padding-right: 48px;
        position: sticky;
        top: 0px;
        z-index: 6;

        &::after {
            content: "";
            position: absolute;
            background: #dde0e7;
            width: 100%;
            height: 1px;
            bottom: -1px;
            left: 0px;
        }

        .interactive-header-menu {
            overflow: hidden;

            .menu-item {
                display: flex;
                column-gap: 10px;
                align-items: center;
                float: left;
                font-size: 16px;
                color: #000;
                text-align: center;
                padding: 38px 20px 38px 20px;
                text-decoration: none;
                cursor: pointer;
                transition: all 0.2s ease-in-out;

                .menu-icon {
                    height: 20px;
                }

                .menu-text {
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 132%;
                }

                &:hover {
                    background-color: #e8ebef;
                }
            }

            .dropdown {
                float: left;
                overflow: hidden;

                .dropbtn {
                    font-size: 16px;
                    border: none;
                    outline: none;
                    color: #000;
                    padding: 38px 20px 38px 20px;
                    background-color: inherit;
                    font-family: inherit; /* Important for vertical align on mobile phones */
                    margin: 0; /* Important for vertical align on mobile phones */
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 132%;
                    display: flex;
                    column-gap: 10px;
                    align-items: center;

                    .menu-icon {
                        height: 20px;
                    }
                }

                .dropdown-content {
                    max-height: 50vh;
                    display: none;
                    position: absolute;
                    background-color: #fff;
                    min-width: 160px;
                    box-shadow: 0px 10px 9px 0px #b1b1b1;
                    z-index: 1;

                    .menu-item {
                        padding: 10px 0px 10px 20px;
                        float: none;
                        display: flex;
                        text-align: left;
                    }
                }

                &:hover {
                    background-color: #e8ebef;

                    .dropdown-content {
                        display: block;
                    }
                }
            }
        }
    }

    @media only screen and (max-width:1450px) {
        .interactive-header{
            padding-right: 0;
            .interactive-header-menu {
                overflow: hidden;

                .menu-item {
                    font-size: 14px;
                    padding: 30px 10px 30px 10px;
                    transition: all 0.2s ease-in-out;

                    .menu-icon {
                        height: 18px;
                    }

                    .menu-text {
                        font-size: 14px;
                    }
                }
                .dropdown {

                    .dropbtn {
                        padding: 30px 10px 30px 10px;
                        font-weight: 500;
                        font-size: 14px;

                        .menu-icon {
                            height: 18px;
                        }
                    }
                }
            }
        }
    }
</style>